import { render, staticRenderFns } from "./Actionzy.vue?vue&type=template&id=85fb0806&"
import script from "./Actionzy.vue?vue&type=script&lang=js&"
export * from "./Actionzy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports